import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VIcon, {
    ref: "marker",
    staticClass: "marker markerPin",
    attrs: {
      "color": _vm.color,
      "size": "30"
    },
    on: {
      "mousedown": _vm.onDragStart
    }
  }, [_vm._v("\n  fal fa-map-pin\n")]);
};
var staticRenderFns = [];
export { render, staticRenderFns };